import { render, staticRenderFns } from "./X-date-picker.vue?vue&type=template&id=1925d8e6&scoped=true"
import script from "./X-date-picker.vue?vue&type=script&lang=js"
export * from "./X-date-picker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1925d8e6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/bitnami/deploy/oscar_front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1925d8e6')) {
      api.createRecord('1925d8e6', component.options)
    } else {
      api.reload('1925d8e6', component.options)
    }
    module.hot.accept("./X-date-picker.vue?vue&type=template&id=1925d8e6&scoped=true", function () {
      api.rerender('1925d8e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/time/X-date-picker.vue"
export default component.exports